import { HttpErrorResponse } from '@angular/common/http';

import type { BillingInformationValidationError } from '@recruitee/billing-information-types';

export abstract class Helpers {
  public static httpToBillingInformationValidationError(
    httpErrorResponse: HttpErrorResponse,
    genericFailMsg?: string,
  ): BillingInformationValidationError {
    const message = httpErrorResponse.error ?? genericFailMsg;

    if (message) {
      return {
        errorCode: message.errorCode ?? '',
        errorDescription:
          message.errorMessage || message.errorDescription || message.error[0] || '',
      };
    }

    return {
      errorCode: '',
      errorDescription: '',
    };
  }
}
